import React, { useState } from 'react'
import './kidsTableChildRow.css'
import ChildRowPopup from './ChildRowPopup'
import { kidDisplayTotals } from '../../service/familyPlanUtil'

export default function KidsTableChildRow({ kid }) {

  const { name, personId, birthday, plan, preBorn } = kid;
  const totals = kidDisplayTotals(kid);

  const [openPopup, setOpenPopup] = useState(false)

  const handleTogglePopup = () => {
    setOpenPopup(prev => !prev)
  }

  const handleKeyDown = (e) => {
    if ([13, 32].includes(e.keyCode)) {
      setOpenPopup(true)
    }
  }

  return (
    <>
      <tr className='registration-child-row'>
        <td className='name'>{name}</td>
        <td className='preson-id'>{personId}</td>
        <td className='birthday'>{(preBorn) ? 'טרום לידה' : birthday}</td>
        <td className='plan-title'>{plan.title}</td>
        <td className='units'>{totals.units}</td>
        <td className='monthly-donation'>₪{totals.monthlyDonation.toLocaleString()}</td>
        <td className='payments'>{totals.payments}</td>
        <td className='total-donation'>₪{totals.totalDonation.toLocaleString()}</td>
        <td className='monthly-return'>₪{totals.monthlyReturn.toLocaleString()}</td>
        <td className='return-payments'>{totals.returnPayments.toLocaleString()}</td>
        <td className='total-loan'>₪{totals.totalLoan.toLocaleString()}</td>
        <td className='total-loan-msg'>סה"כ הלוואה</td>
        <td className='grant'>₪{totals.grant.toLocaleString()}</td>
        <td className="menu-icon-mobile" onClick={handleTogglePopup} tabIndex={0} onKeyDown={handleKeyDown}>
          <img src="./icons/dots-menu.svg" alt='menu icon' />
        </td>
      </tr>
      {(openPopup) && <tr className='child-row-popup-wrapper'><td><ChildRowPopup kid={kid} closePopup={() => setOpenPopup(false)} /></td></tr>}
      <tr className='card-hr'>
        <td colSpan={12}></td>
      </tr>
    </>
  )
}
